import { motion } from "framer-motion";
import { EASE_PORTAL } from "./Reveal";

export default function MaskedLines({
  lines,
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.16,
}) {
  return (
    <motion.span
      className={`block ${className}`}
      initial="hidden"
      animate="visible"
      variants={{
        hidden: {},
        visible: { transition: { staggerChildren: stagger, delayChildren: delay } },
      }}
    >
      {lines.map((line, i) => (
        <span
          key={i}
          className="block overflow-hidden pb-[0.09em] -mb-[0.09em]"
        >
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            variants={{
              hidden: { y: "115%", opacity: 0 },
              visible: {
                y: "0%",
                opacity: 1,
                transition: { duration: 0.95, ease: EASE_PORTAL },
              },
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
}
